<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <div  (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="video-left-pane flex-16">
        <app-scope-pattern-left-navigation-pane></app-scope-pattern-left-navigation-pane>
      </div>
      <div class="flex-80">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

